import { commissionGroupApi } from "api/TenantSlug/CommissionGroup/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import CommissionGroupData = App.Data.CommissionGroupData;

export const useCommissionGroupSelectOptions = () => {
    return useSelectOptions<CommissionGroupData>({
        apiFunction: (payload) => commissionGroupApi.index(payload),
        dataKey: "commissionGroups",
        cacheKey: "commission-group-select",
        queryParams: {
            filter: { sort: "title" },
        },
        mapToOption: (commissionGroup) => ({
            label: commissionGroup.title,
            value: commissionGroup.id,
        }),
    });
};
